import { createSelector } from '@reduxjs/toolkit'
import { setGraphFilters, updateGraphFilter, updateGraphFilters } from 'Actions/graphFilter'
import { getGraphs } from 'Services/GraphFilterUtils'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { withFilterData } from 'Components'
import { store } from '~/Store'
import { GRAPH } from 'Types'
import FilterBody from './FilterBody'
import FilterHeader from './FilterHeader'
import GraphFilterItem from './GraphFilterItem'
import tabStyles from './tabStyles'

graphFilterSelector = createSelector((state) ->
  state.graphFilter.graphFilters
, _.values)

GraphFilterGraphs = ({ items }) ->
  dispatch = useDispatch()
  graphFilters = useSelector(graphFilterSelector)

  [filterValue, setFilterValue] = useState("")

  useEffect(->
    dispatch(setGraphFilters(
      _.keyBy(
        _.sortBy(items, ['enabled', (item) -> item.label.toLowerCase()])
      , 'id')
    ))
    undefined
  , [items])

  CellRenderItem = ({ item, props... }) ->
    itemProps = {
      itemType: GRAPH
      enabled: item.enabled
      value: item.id
      label: item.label
      enableByDefault: true
      ...props
    }

    <GraphFilterItem { itemProps... } />

  <div style={tabStyles}>
    <FilterHeader updateFilters={updateGraphFilters}
                  items={graphFilters}
                  idField='id'
                  onFilter={setFilterValue} />
    <FilterBody items={graphFilters}
                idField='id'
                filterValue={filterValue}
                updateFilter={updateGraphFilter}
                CellRenderItem={CellRenderItem} />
  </div>

export default withFilterData(GraphFilterGraphs, getGraphs, graphFilterSelector)
